import postgreApiService from "./apiService";
import { RPC_PRODUCT_ENDPOINTS } from "../endpoints";
import { getStoredCompanyId } from "../../utils/user";
import { isSuccess } from "./utils";

const formatPrice = (value) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return "€0.00";
    return `€${numeric.toFixed(2)}`;
};

const normalizeProduct = (item) => {
    const image = item?.image || item?.Image || "";
    const rawPrice = item?.productprice ?? item?.ProductPrice ?? item?.Price ?? item?.price;
    const price = rawPrice && String(rawPrice).includes("€") ? String(rawPrice) : formatPrice(rawPrice);

    return {
        id: String(item?.productid ?? item?.ProductID ?? item?.product_id ?? item?.Id ?? item?.id ?? ""),
        name: item?.productname || item?.ProductName || item?.product_name || item?.Name || item?.name || "Unnamed product",
        code: String(item?.item_code ?? item?.ItemCode ?? item?.product_code ?? item?.Code ?? item?.code ?? ""),
        price,
        priceValue: Number(rawPrice) || 0,
        image,
        categoryId: item?.item_category_id ?? item?.ItemCategoryId ?? item?.category_id ?? null,
        link: item?.ReferanceID3 || item?.referanceID3 || item?.link || item?.Link || item?.url || item?.Url || "",
        StockAvailable: item?.StockAvailable ?? item?.stockAvailable ?? null,
    };
};

export const getCategories = async () => {
    const company_id = getStoredCompanyId();
    const response = await postgreApiService.post(RPC_PRODUCT_ENDPOINTS.CATEGORIES, { company_id });
    const data = response?.data || {};
    const list = data?.Data || data?.data || data?.Categories || data?.categories || data;
    const categories = Array.isArray(list)
        ? list.map((item) => ({
            id: item?.categoryid ?? item?.CategoryID ?? item?.id ?? 0,
            name: item?.categoryname || item?.CategoryName || item?.name || String(item),
            nameEn: item?.CategoryNameEnglish || item?.categoryNameEnglish || "",
        })).filter((c) => c.name)
        : [];
    return {
        success: isSuccess(data?.Success),
        categories,
        error: !isSuccess(data?.Success) ? (data?.Message || "") : undefined,
    };
};

export const getProductListPaged = async ({ p_category = 0, p_record_limit = 15, p_page_number = 1 } = {}) => {
    const p_company_id = getStoredCompanyId();
    const response = await postgreApiService.post(RPC_PRODUCT_ENDPOINTS.GET_PRODUCT_LIST_PAGED, {
        p_company_id,
        p_category,
        p_record_limit,
        p_page_number,
    });
    const data = response?.data || {};
    const list = data?.Data || data?.data || data?.Products || data?.products || [];
    const products = Array.isArray(list) ? list.map(normalizeProduct).filter((item) => item.id) : [];
    return {
        success: isSuccess(data?.Success),
        products,
        totalRecords: data?.total_record ?? data?.TotalRecord ?? 0,
        totalPages: data?.Totalpages ?? data?.total_pages ?? data?.TotalPages ?? 1,
        error: !isSuccess(data?.Success) ? (data?.Message || "") : undefined,
    };
};
